import React from 'react';
import classNames from 'classnames';
import { isNullOrUndefined } from 'rewire-common';
import { Observe } from 'rewire-core';
import { IGridFontSizes, IGridColors } from 'rewire-grid';
import { WithStyle } from 'rewire-ui';
import Divider from '@material-ui/core/Divider';
import { Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '../ui/Grid';
import InfoPanelShiftNavigation from './InfoPanelShiftNavigation';
import InfoPanelShiftSchedulingHeaderView from './InfoPanelShiftSchedulingHeaderView';
import infoPanelShiftSchedulingViewModel from './InfoPanelShiftSchedulingViewModel';
import SchedulingCandidateEmployeeGrid from './SchedulingCandidateEmployeeGrid';
import SchedulingCanadidatePhoneDialog from './SchedulingCandidatePhoneDialog';
import { withStyles } from '../utility/styles';

const styles = (_theme: Theme) => ({
  header: {
    display: 'flex',
    flexDirection: 'column',
  },
  shiftNavigation: {
    marginBottom: '10px',
  },
  flexedInnerContainer: {
    display: 'flex',
    marginBottom: '15px',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    '& > :first-child': {
      flex: '1',
      marginRight: '15px',
    },
  },
  shiftGridContainer: {
    flexShrink: 0,
    marginTop: '5px',
    marginBottom: '15px',
    maxHeight: '122px',
    display: 'flex',
    flexDirection: 'column',
  },
  schedulingGridContainer: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '295px',
    marginBottom: '5px',
    flex: '1',
  },
});

interface IInfoPanelShiftSchedulingViewProps {
  classes?: any;
}

type InfoPanelShiftSchedulingViewProps = WithStyle<ReturnType<typeof styles>, IInfoPanelShiftSchedulingViewProps>;

class InfoPanelShiftSchedulingView extends React.Component<InfoPanelShiftSchedulingViewProps> {
  gridFontSizes: IGridFontSizes;
  gridColors: IGridColors;

  constructor(props: InfoPanelShiftSchedulingViewProps) {
    super(props);

    this.gridFontSizes = {
      header: '0.75em',
      body: '0.75em',
      groupRow: '1em',
      toggleMenu: '0.8em',
    };

    this.gridColors = {
      // cellSelectedBackground: '#D0DEE8',
      // cellOutline: 'none',
    };
  }

  renderShiftGrid = React.memo((): JSX.Element => {
    return (
      <Observe
        render={() =>
          (!isNullOrUndefined(infoPanelShiftSchedulingViewModel.shiftGrid?.id) && (
            <Grid
              key={infoPanelShiftSchedulingViewModel.shiftGrid.id}
              grid={infoPanelShiftSchedulingViewModel.shiftGrid}
              gridFontSizes={this.gridFontSizes}
              gridColors={this.gridColors}
            />
          )) ||
          null
        }
      />
    );
  });

  render() {
    const { classes } = this.props;

    return (
      <Observe
        render={() => (
          <>
            <div className={classes.header}>
              <InfoPanelShiftNavigation className={classes.shiftNavigation} title="Shift" />
              <div className={classes.flexedInnerContainer}>
                <Observe
                  render={() => <Typography>{infoPanelShiftSchedulingViewModel.occupation?.name ?? 'No Occupation'}</Typography>}
                />
                <Observe
                  render={() => (
                    <Typography>
                      {infoPanelShiftSchedulingViewModel.toDisplayDateString(infoPanelShiftSchedulingViewModel.earnedDate)}
                    </Typography>
                  )}
                />
              </div>
            </div>
            <div className={classNames(classes.shiftGridContainer)}>
              <this.renderShiftGrid />
            </div>
            <Divider />
            <div className={classes.schedulingGridContainer}>
              <InfoPanelShiftSchedulingHeaderView />
              <SchedulingCandidateEmployeeGrid model={infoPanelShiftSchedulingViewModel.schedulingGridModel} />
            </div>
            <SchedulingCanadidatePhoneDialog />
          </>
        )}
      />
    );
  }
}

export default withStyles(styles, InfoPanelShiftSchedulingView);
